import {
	ApplicationConfig,
	provideBrowserGlobalErrorListeners,
	provideZonelessChangeDetection,
} from '@angular/core'
import { provideRouter } from '@angular/router'
import { AppRoutes } from './config/shared/routes'
import { DateFnsAdapter } from '@angular/material-date-fns-adapter'
import {
	MAT_DATE_FORMATS,
	DateAdapter,
	MAT_DATE_LOCALE,
} from '@angular/material/core'
import { FrontendLanguageBridge } from '@lg/ng-shared'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { AuthInterceptor } from '@lg/ng-shared'
import { AppTrpcServiceInjectionToken, AppTrpcService } from '@lg/ng-shared'
import { AuthService } from '@lg/ng-shared'
import { CsrfService } from '@lg/ng-shared'
import { IdbService } from '@lg/ng-shared'

export const appConfig: ApplicationConfig = {
	providers: [
		provideBrowserGlobalErrorListeners(),
		provideZonelessChangeDetection(),
		provideRouter(AppRoutes),
		// ComponentStore,
		{ provide: DateAdapter, useClass: DateFnsAdapter, deps: [MAT_DATE_LOCALE] },
		//   { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
		{
			provide: MAT_DATE_FORMATS,
			useValue: {
				parse: {
					dateInput: ['dd.MM.yy', 'dd.MM.yyyy'],
				},
				display: {
					dateInput: 'dd.MM.yyyy',
					monthYearLabel: 'MMM yyyy',
					dateA11yLabel: 'LL',
					monthYearA11yLabel: 'MMMM yyyy',
				},
			},
		},
		{
			provide: MAT_DATE_LOCALE,
			useFactory: () => FrontendLanguageBridge.dateLocale,
		},
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
		{ provide: AppTrpcServiceInjectionToken, useClass: AppTrpcService },
		{ provide: AuthService, useClass: AuthService },
		{ provide: CsrfService, useClass: CsrfService },
		{ provide: IdbService, useClass: IdbService },
		provideZonelessChangeDetection(),
	],
}
